<div class="index-shell">
    <app-header [breadcrumbs]="['Potential Packages']" mainHeading="Potential Packages" [links]="['/potential-packages']">
        <div headingButton>
            <div class="packages-header-buttons">
                <span class="notifiable">
                    <button class="add-button filter-button" cll-icon-button (click)="toggleFilters()">
                        <cll-icon type="outlined">filter_list</cll-icon>
                    </button>
                    <span *ngIf="filters.selectedFilters().length > 0" class="notification-dot"></span>
                </span>
                @if ((user()?.permissions?.permissions ?? []).includes('package.create') && (user()?.commissioner?.status)) {
                    <span class="header-buttons-divider"></span>
                    <button class="add-button " cll-icon-button (click)="navigateToAddPackage()">
                        <cll-icon type="outlined">add</cll-icon>
                    </button>
                }
            </div>
        </div>
    </app-header>

    <div class="flex col">
        <div class="package-filter-chips" *ngIf="filtersVisible">
            @if (optionsLoading$ | async) {
                <cll-spinner />
            }
            @if (optionsError$ | async) {
                <cll-panel colour="error" [style.width]="'250px'">
                    <cll-icon cllPanelIcon>error</cll-icon>
                    Failed to load filters. Please try again later.
                </cll-panel>
            }
            @for (filter of filters.selectedFilters(); track filter.name; let last = $last) {
                <app-filter-chip [filter]="filter"
                                 (remove)="filters.removeFilter(filter)" />
                @if (!last) {

                }
            }
            <button class="add" cll-button colour="variant" [cllMenuTriggerFor]="addFilterMenu"
                    aria-label="Open filter menu">
                <cll-icon>add</cll-icon>
                Add filter
            </button>
            @if (filters.selectedFilters().length > 0) {
                <button class="remove" cll-button colour="variant" (click)="removeAllFilters()"
                        aria-label="Remove all filters">
                    <cll-icon>clear</cll-icon>
                    Remove all
                </button>
            }
        </div>

        <ng-template #addFilterMenu>
            <cll-menu>
                @for (filter of filters.availableFilters(); track filter.name) {
                    <button cllMenuItem (click)="filters.addFilter(filter)"
                            [attr.aria-label]="'Add ' + filter.title + ' filter'">
                        {{ filter.title }}
                    </button>
                }
            </cll-menu>
        </ng-template>

        <div class="search-container package_filter nowrap">
            <cll-form-field label="Type a keyword...">
                <cll-icon cllPrefix>search</cll-icon>
                <input [formControl]="searchControl"
                       cllFormInput
                       type="text">

                @if (searchControl.value) {
                    <button (click)="searchControl.reset()"
                            cll-icon-button
                            cllTooltip="Clear search query"
                            cllSuffix>
                        <cll-icon>clear</cll-icon>
                    </button>
                }
            </cll-form-field>
            <div class="package_view_type">
                <span>View: </span>
                <cll-chip-collection>
                    <cll-filter-chip colour="secondary" [selected]="listType() === 'list'"
                                     [disabled]="listType() === 'list'"
                                     (click)="updateListType('list')">List
                    </cll-filter-chip>
                    <cll-filter-chip colour="secondary" [selected]="listType() === 'map'"
                                     [disabled]="listType() === 'map'"
                                     (click)="updateListType('map')">Map
                    </cll-filter-chip>
                </cll-chip-collection>
            </div>
        </div>

        @if (listType() === 'list') {
            @if (pageResult(); as request) {
                @if (request.isLoading) {
                    <cll-spinner />
                }

                @if (request.error; as error) {
                    <app-error-panel [error]="error"/>
                }

                @if (request.value; as page) {
                    <table class="cll-table">
                        <colgroup>
                            <col style="width: 48px;">
                        </colgroup>

                        <thead>
                        <tr>
                            <th>Reference</th>
                            <th>Commissioner</th>
                            <th>Address</th>
                            <th>Creation date</th>
                            <th>Publish date</th>
                            <th>Provider</th>
                            <th>Open</th>
                            <th>Allocation</th>
                            <th></th>
                        </tr>
                        </thead>

                        <tbody>
                            @if (page.data.length === 0) {
                                <tr>
                                    <td colspan="9" class="no-data-row">
                                      <div class="no-data-wrapper">
                                        No packages found.
                                      </div>
                                    </td>
                                  </tr>
                              } @else {
                            @for (packageRow of page.data; track packageRow.id) {
                                <tr [routerLink]="['/packages/', packageRow.id]"
                                    [queryParams]="{ type: 'potential-packages' }"
                                    class="clickable">
                                    <td>{{ packageRow.reference }}</td>
                                    <td>
                                        @if (packageRow.commissioner) {
                                            {{ packageRow.commissioner.name }}
                                        }
                                    </td>
                                    <td>{{ packageRow.address ? packageRow.address.street_1 + ', ' + packageRow.address.post_code : '' }}</td>
                                    <td>{{ packageRow.created_at | appDate: 'dd/MM/yyyy' }}</td>
                                    <td>
                                        @if( packageRow.publish === 'draft'){
                                            Draft
                                        } @else if( packageRow.publish_at !== null) {
                                            {{ packageRow.publish_at | appDate: 'dd/MM/yyyy' }}
                                        } @else {
                                            Immediately
                                        }
                                    </td>
                                    <td>
                                        @if (packageRow.provider) {
                                            {{ packageRow.provider.name }}
                                        }
                                    <td>
                                        @if (!packageRow.open) {
                                            <cll-icon class="cancel-icon" [size]="19" type="outlined">cancel</cll-icon>
                                        } @else {
                                            <cll-icon class="check-icon" [size]="19">check_circle</cll-icon>
                                        }
                                    </td>
                                    <td>
                                        @if(packageRow.region?.name) {
                                            <button class="tool-tip-button" [cllTooltip]="ref2">
                                                {{ packageRow.region?.name }}
                                            </button>
                                            <ng-template #ref2>
                                                <cll-hint>
                                                    <div class="tooltip-container">
                                                        <div>
                                                            <span class="tool-tip-title"><cll-icon type="outlined">explore</cll-icon>Allocation</span>
                                                        </div>
                                                        <div class="tool-tip-region-zone-container">
                                                            <div class="tooltip-region-container">
                                                                <span class="region-zone-title">Region</span>
                                                                <span class="region-zone-name">{{ packageRow.region?.name }}</span>
                                                            </div>
                                                            <div class="tooltip-region-container">
                                                                <span class="region-zone-title">Zone</span>
                                                                <span class="region-zone-name">
                                                                    {{ packageRow.zone?.name }}
                                                                </span>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </cll-hint>
                                            </ng-template>
                                        }  @else {
                                            <button class="tool-tip-button">No region</button>
                                        }
                                    </td>
                                    <td class="align-right">
                                        <button cll-icon-button
                                                [cllMenuTriggerFor]="menu"
                                                (click)="$event.stopPropagation()">
                                            <cll-icon>more_vert</cll-icon>
                                        </button>

                                        <ng-template #menu>
                                            <cll-menu>
                                                <a cllMenuItem
                                                   [routerLink]="['/packages/', packageRow.id]"
                                                   [queryParams]="{ type: 'my-packages' }">
                                                    <cll-icon>open_in_new</cll-icon>

                                                    View package
                                                </a>
                                            </cll-menu>
                                        </ng-template>
                                    </td>
                                </tr>
                            }
                        }
                        </tbody>
                    </table>
                }
            }
        }
        @if (listType() === 'map') {
            @if (pagePinsResult(); as request) {
                @if (request.isLoading) {
                    <cll-spinner />
                }

                @if (request.error; as error) {
                    <cll-panel colour="error">
                        <cll-icon cllPanelIcon>error</cll-icon>
                        {{ error }}
                    </cll-panel>
                }

                <div class="map-list">
                    @if (mapError()) {
                        <cll-panel colour="error">
                            <cll-icon cllPanelIcon>error</cll-icon>
                            Failed to load map. Please try again later.
                        </cll-panel>
                    }
                    <google-map [options]="options"
                                (mapInitialized)="initMap($event)"
                                width="100%"
                                (error)="handleMapError($event)"
                                (mapDragend)="onDrag()"
                                (zoomChanged)="onZoomChange()" />
                    @if (selectedPackageId() !== null) {
                        <div class="map-package-details">
                            <cll-card>
                                <cll-card-header>
                                    <cll-icon cllCardIcon type="outlined">inventory_2</cll-icon>
                                    <cll-card-title>Package details</cll-card-title>
                                    <cll-card-header-actions>
                                        <button cll-icon-button (click)="editSelectedPackage()">
                                            <cll-icon type="outlined">open_in_new</cll-icon>
                                        </button>
                                    </cll-card-header-actions>
                                </cll-card-header>
                                <div class="tabs-container-map" style="max-width:340px">
                                    @if (selectedPackageIds()!.length > 1) {
                                        <cll-horizontal-tabs
                                            [appearance]="'line'"
                                            [accentColour]="'secondary'"
                                            [tabItems]="packageTabItems()"
                                            [currentTabId]="selectedPackageId()??'1'"
                                            (currentTabIdChange)="currentPackageTabIdChange($event)"
                                            class="map-card-tabs"/>
                                    }
                                    <div class="accordion-container">
                                        <div class="map-row-field">
                                            <span class="accordion-row-label">Reference</span>
                                            <span class="accordion-row-data">
                                            {{ selectedPackage()?.reference }}
                                        </span>
                                        </div>
                                        <div class="map-row-field">
                                            <span class="accordion-row-label">Details</span>
                                            <span class="accordion-row-data">
                                            {{ selectedPackage()?.details }}
                                        </span>
                                        </div>
                                        <div class="map-row-field">
                                            <span class="accordion-row-label">Weekly hours</span>
                                            <span class="accordion-row-data">
                                            {{ selectedPackage()?.weekly_hours }}
                                        </span>
                                        </div>
                                        <div class="map-row-field">
                                            <span class="accordion-row-label">Publish date</span>
                                            <span class="accordion-row-data">
                                                @if (selectedPackage()?.publish_at === null) {
                                                    not set
                                                } @else {
                                                    {{ (selectedPackage()?.publish_at ?? '') | appDate:'longDateTime'}}
                                                }
                                        </span>
                                        </div>
                                        <div class="map-row-field">
                                            <span class="accordion-row-label">Post code</span>
                                            <span class="accordion-row-data">
                                            {{ selectedPackage()?.address?.post_code }}
                                        </span>
                                        </div>
                                        <div class="map-row-field">
                                            <span class="accordion-row-label">Carers Required</span>
                                            <span class="accordion-row-data">
                                            {{ selectedPackage()?.carers_required }}
                                        </span>
                                        </div>
                                        <div class="map-row-field" [ngPlural]="selectedPackage()?.clients?.length??0">
                                            <ng-template ngPluralCase="=0">
                                                <span  class="accordion-row-label">No Clients</span>
                                            </ng-template>
                                            <ng-template ngPluralCase="=1">
                                                <span  class="accordion-row-label">Client</span>
                                                <span class="accordion-row-data">
                                                    {{ clientNames() }}
                                                </span>
                                            </ng-template>
                                            <ng-template ngPluralCase="other">
                                                <span>Clients: </span>
                                                @if ((selectedPackage()?.clients ?? []).length < 5) {
                                                    <span class="accordion-row-data">
                                                    {{ clientNames() }}
                                                </span>
                                                } @else {
                                                    <details aria-label="Expand to see the additional client names">
                                                        <summary>{{ clientNamesShort() }}</summary>
                                                        {{ clientNamesMore() }}
                                                    </details>
                                                }
                                            </ng-template>
                                        </div>
                                        <div class="map-row-field">
                                            <span class="accordion-row-label">Open</span>
                                            <span class="accordion-row-data">
                                            @if (selectedPackage()?.open) {
                                                Yes
                                            } @else {
                                                No
                                            }
                                        </span>
                                        </div>
                                    </div>
                                </div>
                            </cll-card>
                        </div>
                    }
                </div>

            }
        }
    </div>
    <app-pagination-card
        (page)="setPage($event)"
        [meta]="meta()"
    />
</div>
